import { useCategoryRevamp } from '@modules/category/hook/use-category-revamp';

/**
 * Whether the 2026 editorial directory revamp is active for this request, for
 * components.
 *
 * Its own module rather than sitting beside isArticlesRevampEnabled: that gate
 * imports a .server module, and importing it from a component puts that module
 * in the browser graph, where the chunk 404s and the whole subtree stops
 * hydrating without an error to show for it.
 */
export const useArticlesRevampEnabled = (): boolean => useCategoryRevamp();
